import React, { Component } from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import GroupSelector from '~/Common-Objects/UI/GroupSelector/GroupSelector';
import axios from '~/data/http/axios';
import AddGroup from '../subscribers/groups/incGoAddGroup'
import FormPicker from '~/pages/cp/includes/formPicker'
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import { connect } from 'react-redux';
import i18n from '~/i18n';

@connect((store) => {
    return { permissionStore: store.permission, accountMaster: store.accountMaster }
})
class FromGroupChange extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedGroupId: -1,
            loaded: false
        }
    }

    componentDidMount() {
        if (this.props.selectedGroupId) {
            this.setState({ selectedGroupId: this.props.selectedGroupId, loaded: true })
        }
        this.setState({ loaded: true })
    }


    render() {
        if (!this.state.loaded) return <></>;
        return (
            <>
                <h4 className="mar-b10">{i18n.t('form:changeGroup.header')}</h4>
                <p className="mar-b25">{i18n.t('form:changeGroup.subHeader')}</p>
                <GroupSelector
                    initialGroupId={this.state.selectedGroupId}
                    groupChanged={(group) => {
                        this.setState({ selectedGroupId: group.id || -1 });
                    }}
                />

                <div className="campaign-type-selector__sticky-footer mar-t20">
                    <div className="campaign-type-selector__sticky-footer__content">
                        <Button
                            disabled={false}
                            className="button-primary mar-r10 cyt-new-campaign-btn"
                            text={i18n.t('form:groupSelect.continue')}
                            onClick={() => {
                                this.props.finished(this.state.selectedGroupId)
                            }}
                        />
                        <Button onClick={() => {
                            this.props.finished(-1)
                        }}>
                            {i18n.t('form:groupSelect.cancel')}
                        </Button>
                    </div>
                </div>

            </>
        );
    }
}



export default FromGroupChange;